import { configured, lastSeen, mfgId, subtype } from '~/helpers/fields-description';
import { NAModule } from '~/models/modules/NAModule.model';

export class LegrandModule extends NAModule {
    hasOperationReset = false;
    isWired = true;
    packaging?: string;
    ergonomics?: string;
    full_feature_supported?: boolean = false;

    get fieldLastSeen() {
        return lastSeen(this.last_seen, this.reachable ? '' : 'error--text');
    }
    get fieldConfigured() {
        return configured(this.configured);
    }
    get fieldMfgId() {
        return mfgId(typeof this.mfg_id !== 'undefined' ? this.mfg_id : undefined);
    }
    get fieldSubtype() {
        return subtype(this.subtype);
    }

}
